module.exports = __webpack_public_path__ + "static/media/dorms.c3fbdb72.svg";